import React, { Component } from 'react'
import BookShelf from './BookShelf'
import { Link } from 'react-router-dom'


class HomePage extends Component {
  render() {
    return (

      <div className="list-books">
        <div className="list-books-title">
          <h1>MyReads</h1>
        </div>
        <div className="list-books-content">
          <div>
            <BookShelf
              books={this.props.books}
              changeShelf={this.props.changeShelf}
              />
          </div>
        </div>
        <div className="open-search">
          <Link
            to="/search"
            className="go-to-search"
            >Add a book</Link>
        </div>
      </div>
    )}
}

export default HomePage



// WEBPACK FOOTER //
// ./src/HomePage.js